import { Inject, Injectable } from '@angular/core';

import { Actions, ofType, createEffect } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';

import { ApiService } from '@usimweb/core/services';
import * as creditsActions from '../actions/credits.action';
import { Env } from '@usimweb/core/models';

@Injectable()
export class CreditsEffects {
  constructor(
    @Inject('environment') private environment: Env,
    private actions$: Actions,
    private apiService: ApiService
  ) {}

  private DEBUG_TIME: number = this.environment.production === true ? 0 : 1000;

  $loadVelaInput = createEffect(() => {
    return this.actions$.pipe(
      ofType(creditsActions.LOAD_CREDITS),
      switchMap(() => {
        return this.apiService.getCredits().pipe(
          map((compare) => {
            return new creditsActions.LoadCreditsSuccess(compare);
          }),
          catchError((error) => of(new creditsActions.LoadCreditsFail(error)))
        );
      })
    );
  });
}
